module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-flex",
      "height": "100%"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "icon": "image",
      "label": "Add pictures"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onBtnClick()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.id,
      "accept": "image/png,image/jpg",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.fileInputChanged
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c339edc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/MultipleImageUploader.vue
// module id = 3658
// module chunks = 1